// provide analytics wrapper and util methods.
// in this file we are using window.gtag which is provided by gtag.js, this is
// bootstrapped in the appConfig.js file.

// Sends a named GA4 event, with its parameters when given. No-op when gtag is
// not loaded (local development, tests, blocked scripts).
export function trackEvent(name, params) {
  if (typeof window.gtag !== "function") {
    return;
  }
  window.gtag("event", name, ...(params ? [params] : []));
}

// Fires when an estate agent follows the "Refer a new client" link on their
// dashboard. Whether the visit turns into a lead is attributed separately, by
// the utm params on the link itself.
export function trackReferralLinkClicked() {
  trackEvent("referral_link_clicked");
}

// Fires when an estate agent opens the Referrals tab. Nothing else on the
// dashboard is instrumented and the hourly idle refresh pollutes
// last_active_at, so this is how "do agents use the tab" gets answered.
export function trackReferralsTabOpened() {
  trackEvent("referrals_tab_opened");
}

// Fires each time a quote "sorry" page is shown. Most reasons are a knock-out
// question answered Yes, which never reaches the quote table, so this is the
// only record of how often each question turns people away. `leg` is the half
// of the move that was rejected (buying or selling), `transaction_type` the
// whole move, and `reasons` every reason shown, comma-separated. The flow
// (website, /refer or broker) comes from the event's page_location.
export function trackQuoteRejection({ leg, transactionType, reasons }) {
  trackEvent("quote_rejected", {
    leg,
    transaction_type: transactionType,
    reasons: reasons.join(","),
  });
}
